import { ActiveFilters } from '@aipb/gulliver/personal-content/data-access';
import { MessageFilter } from '@aipb/gulliver/personal-content/model';

import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pc-message-filter',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatButtonModule, ReactiveFormsModule, TranslocoModule],
  templateUrl: './message-filter.component.html',
  styleUrls: ['./message-filter.component.scss']
})
export class MessageFilterComponent implements OnChanges {
  @Input() lang: string;
  @Input() filters: MessageFilter[] = [];
  @Input() activeFilters: ActiveFilters = {};

  @Output() filter = new EventEmitter<Record<string, string[]>>();

  formGroup: FormGroup;

  ngOnChanges() {
    const groups: any = {};

    this.filters.forEach((filter) => {
      groups[filter.filterKey] = new FormControl('');
    });

    Object.keys(this.activeFilters)
      .filter((key) => key in groups)
      .forEach((filterKey) => {
        groups[filterKey].setValue(this.activeFilters[filterKey]);
      });

    this.formGroup = new FormGroup(groups);
  }

  onFilter() {
    this.filter.emit(this.formGroup.value);
  }
}
